//  $(document).ready(function() {
//   var descElement = $('.collection-header-block .banner-highlight .desc');
//   var descText = descElement.text();
//   var maxWidth = $('.collection-header-block .banner-highlight .desc').outerWidth(true)-20;
//   var lineHeight = parseInt(descElement.css('line-height'));
//   var maxLines = 10;
//   var truncatedText = descText;

//   // 计算每行的最大字符数
//   var charsPerLine = Math.floor(maxWidth / (parseInt(descElement.css('font-size')) / 2));

//   // 清空原始文本
//   descElement.empty();

//   // 分割文本为三行
//   var words = truncatedText.split(' ');
//   var lineText = '';
//   var lineCount = 0;
//   var spanCount = 0;

//   for (var i = 0; i < words.length; i++) {
//     var word = words[i];
//     var tempText = lineText + word;

//     // 检查是否超出行宽
//     if (tempText.length <= charsPerLine) {
//       lineText = tempText + ' ';
//     } else {
//       // 创建每行的 span 元素，并添加到 desc 元素中
//       var spanElement = $('<span>').text(lineText.trim());
//       descElement.append(spanElement);

//       // 添加换行符
//       if (lineCount < maxLines - 1) {
//         descElement.append('<br>');
//       }

//       lineText = word + ' ';
//       lineCount++;
//       spanCount++;

//     }
//   }

//   // 添加最后一行的 span 元素
//   var lastLineElement = $('<span>').text(lineText.trim());
//   descElement.append(lastLineElement);
//   let seeMoreLinkStatus=$('.see-more-link').length>0;
//   // 检查 span 的数量并添加 .see-more-link
//   if (spanCount >= maxLines) {
//     // 在第三个 span 后面添加 .see-more-link
//     var seeMoreLink = $('.see-more-link');
//     descElement.find('span:last-child').after(seeMoreLink);
//     // descElement.find('span:eq(2)').addClass('more-span');
//     if(seeMoreLinkStatus){
//       descElement.find('span:last-child').addClass('has-link-span');
//     }
//     if (lineCount >= maxLines && !seeMoreLinkStatus) {

//       console.log(lastLineElement,seeMoreLinkStatus,"seeMoreLinkStatus");

//       descElement.find('span:last-child').append('...');
//           }
//   } else {
//     // 在最后一个 span 添加 .see-more-link
//     var seeMoreLink = $('.see-more-link');
//     lastLineElement.after(seeMoreLink);
//     lastLineElement.addClass('more-span');
//     if(seeMoreLinkStatus){
//       lastLineElement.addClass('has-link-span');
//     }

//   }
// });

function sortBy(that) {
  $(that).addClass("selected").siblings().removeClass("selected");
}

function sortByResult() {
  let href = $(".nt_ajaxsortby a.selected").data("href");
  console.log(href);
  window.location.href = href;
}

$(document).on("click", function (event) {
  var targetElement = $(event.target);

  if (!targetElement.closest(".nt_ajaxsortby").length) {
    $(".cat_sortby").removeClass("opended");
  }
});

// 移动端筛选弹窗
function closeMbFilter() {
  console.log(23234343);
  $(".template-collection button.mfp-close").click();
}

let mbFilterStatus = true;
function openMbFilter() {
  if (mbFilterStatus) {
    console.log("1212121212");
    $("#shopify-section-sidebar_shop2 .cat_fixcl-scroll").append(
      $(".popup-filter-btn-box")
    );
    setTimeout(function () {
      $(".collection-fiter-mb-title-box").append(
        $(".template-collection .mfp-ready .mfp-close")
      );
    }, 200);
    mbFilterStatus = false;
  }
}

// 处理移动端颜色筛选点击 - 阻止跳转，只切换状态
$(document).on("click", ".mobile-filter-link", function (e) {
  e.preventDefault();
  e.stopPropagation();
  var $link = $(this);
  var $li = $link.closest("li");
  $li.toggleClass("active");
});

$(document).on("click", ".ns-filter-result_slider_btn", function (e) {
  // 收集元字段：产品价值等级所有选中的筛选
  var selectedSeriesValueScoreFilters = [];
  $("#blockid_series_value_score .mobile-filter-link").each(function () {
    var $link = $(this);
    var $li = $link.closest("li");
    if ($li.hasClass("active")) {
      var seriesValueScoreKey = $link.data("key");
      var seriesValueScoreValue = $link.data("value");
      if (seriesValueScoreKey && seriesValueScoreValue) {
        selectedSeriesValueScoreFilters.push(seriesValueScoreKey + seriesValueScoreValue);
      }
    }
  });

  var seriesValueScoreFilterStr =
    selectedSeriesValueScoreFilters.length > 0 ? selectedSeriesValueScoreFilters.join("+nt+") : "";

  // 收集所有选中的颜色筛选
  var selectedColorFilters = [];
  $("#blockid_color .mobile-filter-link").each(function () {
    var $link = $(this);
    var $li = $link.closest("li");
    if ($li.hasClass("active")) {
      var colorKey = $link.data("color-key");
      var colorValue = $link.data("color-value");
      if (colorKey && colorValue) {
        selectedColorFilters.push(colorKey + colorValue);
      }
    }
  });

  var colorFilterStr =
    selectedColorFilters.length > 0 ? selectedColorFilters.join("+nt+") : "";

  // 处理价格筛选逻辑
  var $priceWrapper = $(".price_slider_amount"),
    $minPrice = $priceWrapper.find(".min_price"),
    $maxPrice = $priceWrapper.find(".max_price"),
    originalUrl = $priceWrapper.find(".url_price").val(),
    minPriceData = $minPrice.data("min"),
    maxPriceData = $maxPrice.data("max"),
    minPriceVal = $minPrice.val(),
    maxPriceVal = $maxPrice.val();

  // 从原始URL中提取sort_by参数
  var sortByParam = "";
  if (originalUrl) {
    var sortByMatch = originalUrl.match(/[?&]sort_by=([^&]+)/);
    if (sortByMatch) {
      sortByParam = sortByMatch[1];
    }
  }

  // 从DOM中获取筛选条件
  var filterParts = [];

  // 处理价格筛选：如果价格不是最小值和最大值，则添加价格筛选
  if (!(minPriceData == minPriceVal && maxPriceData == maxPriceVal)) {
    var priceFilter =
      "filternt_price%3d" + minPriceVal + "+ntprice+" + maxPriceVal;
    filterParts.push(priceFilter);
  }

  // 处理颜色筛选：如果有选中的颜色，添加颜色筛选
  if (colorFilterStr) {
    filterParts.push("filter_color%3d" + colorFilterStr);
  }

  // 处理产品系列等级筛选：如果有选中的系列等级，添加系列等级筛选
  if (seriesValueScoreFilterStr) {
    filterParts.push("filter_series_value_score%3d" + seriesValueScoreFilterStr);
  }

  // 构建filterUrl：基础URL + 筛选条件 + sort_by（在末尾）
  var baseUrl = originalUrl
    ? originalUrl.split("?")[0]
    : window.location.href.split("?")[0];
  var filterUrl = baseUrl;

  if (filterParts.length > 0) {
    var filterStr = filterParts.join("+nt+");
    filterUrl = baseUrl + "?q=" + filterStr;
  }

  // 确保sort_by在末尾
  if (sortByParam) {
    if (filterUrl.indexOf("?") > -1) {
      filterUrl = filterUrl + "&sort_by=" + sortByParam;
    } else {
      filterUrl = filterUrl + "?sort_by=" + sortByParam;
    }
  }

  window.location.href = filterUrl;

  return false; // 阻止默认行为，因为我们已经处理了跳转
});

// 处理产品系列等级筛选展示逻辑
$(document).on("lazyincluded", ".collection_sidebar", function (e) {
  var $sidebar = $(this);
  var showLevelFilter = $sidebar.data("show-level-filter");
  if (showLevelFilter === true || showLevelFilter === "true") {
    $sidebar.find("#blockid_series_value_score").removeClass("!ns-hidden");
    $sidebar.find("[data-dialog-trigger='ns-level-popup']").removeClass("!ns-hidden");
  }
});

// Dialog Initialization for Level Explanation Popup and others
if (!window.nsDialogInitialized) {
  $(document).on("click", '[data-dialog-trigger]', function (e) {
    // Handle Open
    e.preventDefault();
    const dialogId = $(this).attr('data-dialog-trigger');
    const dialog = document.getElementById(dialogId);
    if (dialog) {
      dialog.classList.remove('ns-dn');
      // Add active class after a tiny delay for CSS transition to trigger
      setTimeout(() => {
        dialog.classList.add('ns-is-active');
        document.body.style.overflow = 'hidden'; // Prevent scrolling
      }, 10);
    }
  });

  $(document).on("click", '[data-dialog-close]', function (e) {
    // Handle Close from close button
    const dialogId = $(this).attr('data-dialog-close');
    const dialog = document.getElementById(dialogId);
    if (dialog) {
      dialog.classList.remove('ns-is-active');
      setTimeout(() => {
        dialog.classList.add('ns-dn');
        document.body.style.overflow = '';
      }, 300); 
    }
  });

  $(document).on("click", '.ns-dialog-overlay', function (e) {
    // Handle Close from clicking on overlay
    if (e.target.classList.contains('ns-dialog-overlay')) {
      e.target.classList.remove('ns-is-active');
      setTimeout(() => {
        e.target.classList.add('ns-dn');
        document.body.style.overflow = '';
      }, 300);
    }
  });
  window.nsDialogInitialized = true;
}
